import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import InterviewListTabPane from "./InterviewListTabPane";
import { useGeneralContext } from "../../General/Context";
import "../../styles/header.scss";
import ConversationIcon from "../../../layout/left_menu_icons/conversation.svg";

const InterviewPage = () => {
  const { t } = useTranslation();
  const { userInformation } = useGeneralContext();






  
  return (
    <>
      <header className="page-header">
        <div className="header-title">
          <div className="title">
            <img src={ConversationIcon} alt="ni-icon" />
            <h1 style={{marginTop:"10px"}}>{t("Interviews")}</h1>
          </div>
          <div className="subtitle">{t("Recruitment / Interviews")}</div>
        </div>
        <div>
          <div className="text-end col-auto">
            {userInformation.permissions.Create_Edit_Interview && (
              <Link
                to="/interview/createoredit"
                style={{ textDecoration: "none" }}
              >
                <span className="app-button btn-prime btn-lg">
                  {t("+ Interview")}
                </span>
              </Link>
            )}
          </div>
        </div>
      </header>
      <InterviewListTabPane />
    </>
  );
};

export default InterviewPage;
